import { Navigate } from "react-router-dom";
import { isLogin } from "api/checkAuthority";

const PublicRoute = ({ children, restricted = false }) => {
  if (isLogin() && restricted) return <Navigate to={-1} />;
  return children;
};

export default PublicRoute;